"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeckyPropsInitialStoreSym = void 0;
exports.BeckyPropsInitialStoreSym = Symbol('BeckyPropsInitialStoreSym');
//# sourceMappingURL=beckyPropsInitialStore.js.map